import { Button } from '@amzn/awsui-components-react';
import React from 'react';
import { useIntl } from 'react-intl';
import accountlinkConsentMessages from '../i18n/accountlinkConsent.messages';
import { AuthToken, marshalAuthToken } from '../utils/authToken';
import { emitAccountLinkingRUMEvents } from '../services/emitAccountLinkingRUMEvent';
import { localStorageAdapter } from '../services/storage';
import { AppURL } from '../constants/urls';
import { useHistory } from 'react-router';
import { LAST_USED_GANDALF_TOKEN, LAST_USED_TOKEN } from '../constants/auth';

export const ICANT_BUTTON_DATA_ID = 'al_icant';

export const AccountLinkICantButton = ({
  authToken,
  nonce,
  provider,
  validAccountLink,
}: {
  authToken: AuthToken;
  nonce: string;
  provider: string;
  validAccountLink: boolean;
}): JSX.Element => {
  const { formatMessage } = useIntl();

  const history = useHistory();

  const initiateICantFlow = () => {
    emitAccountLinkingRUMEvents(
      authToken.jwtToken,
      'confirm_existing_profile_i_cant_button'
    );
    const marshaledAuthToken = marshalAuthToken(authToken);

    localStorageAdapter.setItem(LAST_USED_TOKEN, marshaledAuthToken);
    localStorageAdapter.setItem(LAST_USED_GANDALF_TOKEN, marshaledAuthToken);
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set('identity_provider', provider);
    history.push({
      pathname: AppURL.CantValidateExistingAccount,
      search: urlParams.toString(),
      state: {
        customState: nonce,
        validAccountLink: validAccountLink,
      },
    });
  };

  return (
    <>
      <Button
        onClick={(e) => {
          e.preventDefault();
          initiateICantFlow();
        }}
        data-testid={ICANT_BUTTON_DATA_ID}
      >
        {formatMessage(
          accountlinkConsentMessages.cantConfirmExistingProfileOwnershipButton
        )}
      </Button>
    </>
  );
};
